// Core
import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';// Vendors
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Routes
import {AppRoutingModule} from './app.routes';
// Components
import { FakeloaderComponentModule } from '@signature-it/ngx-generic/components/fakeloader';
import { RequestOptionsProvider, EventBusService } from '@signature-it/ngx-generic/services';
import { CustomTranslateLoader, HttpTranslateLoaderFactory } from '@signature-it/ngx-generic/loaders';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import {AppComponent} from './app.component';
import {AppStoreModule} from './stores/app/app.store';
import {StyleGuideModule} from './components/style-guide/style-guide.module';
import { AnimatedDigitComponentModule} from "./components/animated-digit/animated-digit.module";
import {ContentTabsModuleGeneric} from "@signature-it/ngx-entity/components/content-tabs";
import {SearchPageInputModuleGeneric} from '@signature-it/ngx-entity/components/e-search/e-search-page-input';
import {QuickPadService_Generic} from '@signature-it/ngx-catalogue/services';
import {QuickPadService} from './services/quick-pad.service';
import {RfqBtnModule} from './components/rfq/rfq-btn/rfq-btn.module';
import {AddProductModule} from './components/add-product/add-product.module';
import {PricePerUnitModule} from './components/price-per-unit/price-per-unit.module';
import {ProductCardModule} from './components/card/products-cards/product-card/product-card.module';
import {EshopBtnModule} from './components/eshop/eshop-btn/eshop-btn.module';

import { SocialShareModule } from './components/social-share/social-share.module';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FakeloaderComponentModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslateLoader,
                useFactory: (HttpTranslateLoaderFactory),
                deps: [HttpClient, RestUrlsConfig, EventBusService]
            }
        }),
        AppRoutingModule,
        AppStoreModule,
        StyleGuideModule,
        AnimatedDigitComponentModule,
        ContentTabsModuleGeneric,
        SearchPageInputModuleGeneric,
        RfqBtnModule,
        AddProductModule,
        PricePerUnitModule,
        ProductCardModule,
        EshopBtnModule,
        SocialShareModule
    ],
    declarations: [
        AppComponent
    ],
    providers: [
        CookieService,
        RequestOptionsProvider,
        { provide: QuickPadService_Generic, useExisting: QuickPadService },
        provideHttpClient(withInterceptorsFromDi())
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
